import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "title" }
const _hoisted_2 = ["innerHTML"]

import {computed, ref, watch} from 'vue';
    import store from '../../../store';
    import {MutationsType} from '../../../store/modules/brief/mutations';
    import {useBriefStrategyStore} from '@/brief-hub/stores/briefStrategy.store';
    import {VJoyDialog} from '@maltjoy/core-vue';
    import {useGlobalProperties} from '@malt/vue3-use';

    interface Props {
        type: 'regular' | 'strategy';
    }
    
export default /*@__PURE__*/_defineComponent({
  __name: 'BriefAdvancedFeatureInformationDialog.client',
  props: {
    type: {}
  },
  setup(__props: any) {

    const {$features, $msg} = useGlobalProperties();

    const advancedFeatureDialog = ref<InstanceType<typeof VJoyDialog>>();
    const informationModalDisplayed = ref<boolean>(store.getters.informationModalDisplayed);
    const briefStrategyStore = useBriefStrategyStore();
    const draftAlreadyCreated = computed<boolean>(() => {
        if (props.type === 'regular') {
            return !!store.getters.brief?.briefId;
        } else {
            return !!briefStrategyStore.brief?.id;
        }
    });

    const confirmText = computed(() => $msg(`customer.brief.form.freelancer.profile.advanced.feature.modal.action.malt.${props.type}`));

    const props = __props;

    watch(
        [store.getters.connectedUser, advancedFeatureDialog],
        () => {
            if (
                !informationModalDisplayed.value &&
                !draftAlreadyCreated.value &&
                (!store.getters.connectedUser || store.getters.connectedUser.serviceLevelType === 'STANDARD')
            ) {
                advancedFeatureDialog.value?.show();
                store.commit(MutationsType.INFORMATION_MODAL_DISPLAYED);
            }
        },
        {immediate: true},
    );

    function tryBrief() {
        advancedFeatureDialog.value?.hide();
    }

    function explorePlans() {
        const pageSource = 'blocker';
        const sourceComponent = 'brief_advanced_feature_information_dialog';
        let redirectUrl =
            props.type === 'regular' ? '/customer/searches/draft/new/freelancer-profile' : '/customer/searches/strategy/draft/new/freelancer-profile';
        redirectUrl += '?referrer=' + document.referrer;
        window.location.href = `/client-settings/service-level?pageSource=${pageSource}&sourceComponent=${sourceComponent}&successRedirectPath=${redirectUrl}&dropRedirectPath=${redirectUrl}`;
    }

return (_ctx: any,_cache: any) => {
  const _component_VJoyButton = _resolveComponent("VJoyButton")!

  return (_openBlock(), _createBlock(_unref(VJoyDialog), {
    ref_key: "advancedFeatureDialog",
    ref: advancedFeatureDialog,
    "confirm-text": confirmText.value,
    "pattern-brand": true,
    "data-testid": "advanced-feature-dialog",
    "onDialog:confirm": tryBrief
  }, {
    "dialog-header": _withCtx(() => [
      _createElementVNode("p", _hoisted_1, _toDisplayString(_unref($msg)('customer.brief.form.freelancer.profile.advanced.feature.modal.title')), 1)
    ]),
    "dialog-subheader": _withCtx(() => [
      _createElementVNode("p", {
        innerHTML: _unref($msg)(`customer.brief.form.freelancer.profile.advanced.feature.modal.body.malt.${props.type}`)
      }, null, 8, _hoisted_2)
    ]),
    "dialog-body": _withCtx(() => _cache[0] || (_cache[0] = [
      _createElementVNode("img", {
        width: "260",
        src: "//dam.malt.com/brief/behold"
      }, null, -1)
    ])),
    "dialog-cancel": _withCtx(() => [
      _createVNode(_component_VJoyButton, {
        class: "joy-dialog--cancel",
        variant: "ghost",
        onClick: explorePlans
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref($msg)('customer.brief.form.freelancer.profile.advanced.feature.modal.cta')), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["confirm-text"]))
}
}

})